import React, { useState, useEffect, useRef } from "react";
import ClientHeader from "./Partials/ClientHeader";
import ClientSideBar from "./Partials/ClientSideBar";
import "../assets/css/button.css";
import "../assets/css/candidate-thank-you.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { getPayment } from "../Actions/paymentAction";
import FeatherIcon from "feather-icons-react";
import Loader from "./Common/loader";
import BillTable from "./PaymentScreen/BillTable";
import SmryTable from "./PaymentScreen/SmryTable";

const Payment = () => {
  const storePaymentData = useSelector((state) => state.payment);
  const storeSavePaymentData = useSelector((state) => state.paymentSave);

  const { paymentData, loading, error } = storePaymentData;
  const { paymentSaveData, loadingData, err } = storeSavePaymentData;
  const [isLoading, setLoading] = useState(false);
  const navigate=useNavigate();

  const handleBack = () => {
    // Implement your logic for navigating back
    console.log("Navigating back...");
    navigate("/candidate-form/client-thank-you-with-pay/");
  };

  useEffect(() => {
    if (typeof loading !== "undefined" && loading !== null) {
      if (loading == true) {
        setLoading(true);
      } else {
        setLoading(false);
      }
    }
  }, [loading]);

  useEffect(() => {
    if (typeof loadingData !== "undefined" && loadingData !== null) {
      if (loadingData == true) {
        setLoading(true);
      } else {
        setLoading(false);
      }
    }
  }, [loadingData]);
  return (
    <>
      {isLoading && <Loader />}
      <ClientHeader />
      <ClientSideBar activePage="dashboard" />
      <div
        className="mt-5 ml-5"
        style={{ overflowX: "hidden", maxWidth: "97%" }}
      >
        <div
          className="container-fluid w-100 h-100 ml-4 mt-4"
          style={{ overflowX: "hidden" }}
        >
          <div className="card-header bg-white d-flex justify-content-start align-items-center">
            <div className="btn btn-outline-secondary mr-3" onClick={handleBack}>
              <FeatherIcon icon="arrow-left" className="mr-3 cursor-pointer" />
              <span>Back</span>
            </div>
            <span
              style={{
                width: "443px",
                height: "38px",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "30px",
                lineHeight: "38px",
                color: "#101828",
                flex: "none",
                order: 0,
                alignSelf: "stretch",
                flexGrow: 0,
              }}
            >
              Complete payment:
              {paymentData?.data?.paymentData?.length}
            </span>
          </div>
          <div className="card-body bg-white">
            <div className="row">
              <div className="col-lg-7 col-md-12 col-sm-12">
                <BillTable />
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12">
                <SmryTable />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
